import { isArray } from 'lodash';

const getBackgroundImageStyle = (url?: string | (string | null | undefined)[]) => {
  if (isArray(url)) {
    const backgroundImage = url
      .reduce((urls, url) => {
        url && urls.push(`url(${url})`);
        return urls;
      }, [] as string[])
      .join(',');
    return backgroundImage.length ? { backgroundImage } : undefined;
  } else if (url) {
    return { backgroundImage: `url(${url})` };
  }
  return undefined;
};

export default getBackgroundImageStyle;
